export default __webpack_public_path__ + "static/media/logo.294a4b61.jpg";